export const AREAS_ERROR = 'AREAS_ERROR';
export const AREAS_REQUEST = 'AREAS_REQUEST';
export const AREAS_SUCCESS = 'AREAS_SUCCESS';
